import { createContext } from 'react';

import {
  TNewAppraisalFlowRequest,
  TDelegatedJob,
} from '@app-velocity/av-api-v2';

export type NewReviewContextType = {
  mode: 'guest' | 'authorized';
  workspaceId: string;
  teamId: string;
  onReviewStart?: (
    body: TNewAppraisalFlowRequest
  ) => Promise<TDelegatedJob | undefined>;
  goToAppraisalDetails?: (
    teamId: string,
    workspaceId: string,
    reviewId: string
  ) => string;
};

export const NewReviewContext = createContext<NewReviewContextType>({
  mode: 'guest',
  workspaceId: '',
  teamId: '',
});
